export const HOMEPAGE_SLUG = '/'
